import ABCyaPhaser from "@abcya/abcya_phaser";
import gameData from "../gameData";

export default class ToggleCaseButton extends Phaser.GameObjects.Container {
  constructor(scene, x, y) {
    super(scene, x, y);

    this.bg = ABCyaPhaser.Images.addImage(0, 0, "CaseButton", this).setOrigin(0.5);

    this.typeLabel = ABCyaPhaser.Images.addImage(0, 0, "lblUC", this).setOrigin(0.5);

    this.lbl = ABCyaPhaser.Images.addImage(0, 0, "CaseLabel", this).setOrigin(0.5);
    this.lbl.y = this.bg.height / 2 + 20;

    ABCyaPhaser.Container.setContainerInteractive(this);
    this.on(Phaser.Input.Events.GAMEOBJECT_POINTER_DOWN, this.handleClick, this);
  }

  handleClick() {
    gameData.isUppercase = !gameData.isUppercase;
    this.typeLabel.setFrame(gameData.isUppercase ? "lblUC" : "lblLC").setOrigin(0.5);
  }
}